import { SupportChatAssistantState, SupportChatContext } from '../types'
import ChatError from '../../../common/ChatError'

export default async function awaitContext({
  assistantState
}: {
  assistantState: SupportChatAssistantState
}): Promise<SupportChatContext> {
  if ('function' !== typeof assistantState.contextGetter) {
    const fallbackUrl = typeof window !== 'undefined' ? window.location?.href || '' : ''
    if (!fallbackUrl) {
      throw new ChatError('Context getter is not set and no fallback URL available')
    }
    return { url: fallbackUrl }
  }

  let context: SupportChatContext | null = assistantState.contextGetter()

  let attempts = 0
  const maxAttempts = 20

  while (null == context?.url && attempts < maxAttempts) {
    await new Promise(resolve => setTimeout(resolve, 500))
    if ('function' !== typeof assistantState.contextGetter) {
      const fallbackUrl = typeof window !== 'undefined' ? window.location?.href || '' : ''
      if (fallbackUrl) {
        return { url: fallbackUrl }
      }
      throw new ChatError('Context getter is not set')
    }
    context = assistantState.contextGetter()
    attempts++
  }

  if (null == context?.url) {
    const fallbackUrl = typeof window !== 'undefined' ? window.location?.href || '' : ''
    if (fallbackUrl) {
      return { url: fallbackUrl }
    }
    throw new ChatError('Unable to get context URL')
  }

  return context
}
